const AgeGroupType = Object.freeze({
    CUB: Symbol("CUB"),
    SCOUT: Symbol("SCOUT"),
});

export default AgeGroupType;
